import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import AccountsPackItemForm from '../../../components/forms/AccountsPackItemForm';
import { useAccountsPackItemApi } from '../../../hooks/useAccountsPackItemApi';
import { useNavigate, useParams } from 'react-router-dom';
import { AccountsPackItemDTO } from '../../../services/apiClient';

const AccountsPackItemEdit: React.FC = () => {
  const { getById, edit } = useAccountsPackItemApi();
  const [entityData, setEntityData] = useState<AccountsPackItemDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Accounts Pack Items', href: '/admin/accountspackitems' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching AccountsPackItem data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/accountspackitems');
    } catch (error) {
      console.error('Error updating AccountsPackItem:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/accountspackitems"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.AccountsPackItem.Edit'
    >
        {entityData ? (
          <AccountsPackItemForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/accountspackitems')}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default AccountsPackItemEdit;